module.exports = __webpack_public_path__ + "img/buy_disabled.d7d132d1.png";